import { dimensionsFor, type AspectRatio } from "./aspectRatios";

// Allow only small model/raster rounding: at most 1% of either axis would
// be lost by a cover resize. Unlike ratio snapping this is relative, not
// an absolute tolerance that is much more permissive for tall canvases.
export function matchesReframeGeometry(width: number, height: number, ratio: AspectRatio): boolean {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return false;
  const target = dimensionsFor(ratio);
  const relative = (width / height) / (target.width / target.height);
  return 1 - Math.min(relative, 1 / relative) <= 0.01;
}

export function assertReframeGeometry(width: number, height: number, ratio: AspectRatio): void {
  if (!matchesReframeGeometry(width, height, ratio)) {
    const error = new Error(`This preview does not match ${ratio}. It has not been saved because resizing would crop the creative. Keep or discard this preview; generating another version requires an explicit action.`);
    error.name = "ReframeGeometryError";
    throw error;
  }
}
